import styled, { css } from 'styled-components';

export const BackgroundWrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    border-radius: 16px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      background: '#ffffff';
      border-radius: 0;
      padding: 0;
    }
  `}
`;

export const GuideContainer = styled.div`
  ${({ theme }) => css`
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 9999;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      display: none;
    }
  `};
`;

export const HighlightWrapper = styled.div`
  ${({ theme, $width, $backgroundStudio }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 40px;
    padding: 32px 24px;
    position: relative;
    width: ${`calc(${$width || 100}% - ${!$width || $width === 100 ? '0px' : '8px'})`};
    min-height: 430px;
    border-radius: 16px;

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 16px;
      pointer-events: none;
      background: linear-gradient(180deg, #D7BDE8 0%, #FEE3C8 100%);
      opacity: ${$backgroundStudio ? 1 : 0};
      transition: opacity 0.4s;
      z-index: 0;
    }

    > * {
      position: relative;
      z-index: 1;
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 0;
      gap: 0;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      min-height: 196px;
      flex-direction: column;
      gap: 0;
      align-items: center;
      white-space: nowrap;
      overflow-x: auto;
    }
  `}
`;

export const MenuHighlight = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    gap: 24px;
    justify-content: center;
    scroll-behavior: smooth;
    white-space: nowrap;
    overflow-x: auto;
    padding-top: 16px;
    margin-top: -16px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      gap: 8px;
      justify-content: flex-start;
      overflow-x: scroll;
      padding: 16px 20px 12px 20px;
      width: 100%;
    }

    ::-webkit-scrollbar {
      display: none;
    }
  `}
`;

export const MenuHighlightButton = styled.button`
  ${({ theme, active }) => css`
    align-items: center;
    background-color: ${active ? theme.v2.colors.brand.primaryLowLight : theme.v2.colors.neutral.highPure};
    border: none;
    border-radius: 39.5px;
    color: ${theme.v2.colors.brand.primaryExtraDark};
    cursor: pointer;
    display: flex;
    flex: 0 0 auto;
    justify-content: center;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    outline: none;
    padding: 12px 24px;
    transition: background-color 0.3s;
    position: relative;

    :hover {
      background-color: ${theme.v2.colors.brand.primaryLowLight};
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding: 12px;
    }
  `}
`;

export const TagNewAdapter = styled.span`
  position: absolute;
  top: -13px;
  right: 16px;
`;

export const MenuHighlightIcon = styled.div`
  display: flex;
  padding-right: 8px;
`;

export const MenuHighlightTitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const SkeletonHighlightWrapper = styled.div`
  ${({ theme, skeleton, width }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 40px;
    justify-content: ${skeleton ? 'flex-start' : 'center'};
    min-height: 430px;
    padding: ${skeleton ? '44px 0 70px 0' : '32px 0'};
    position: relative;
    width: ${`calc(${width || 100}% - ${!width || width === 100 ? '0px' : '8px'})`};

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      min-height: 196px;
      flex-direction: column;
      gap: 0;
      align-items: center;
      white-space: nowrap;
      overflow-x: auto;
      padding: ${skeleton ? '44px 0 70px 0' : '24px 0'};
    }
  `}
`;

export const SkeletonWrapper = styled.div`
  ${({ theme, column, alignStart }) => css`
    align-items: ${alignStart ? 'flex-start' : 'center'};
    display: flex;
    flex-direction: ${column ? 'column' : 'row'};
    flex-wrap: wrap;
    gap: ${column ? '44px' : '20px'};
    justify-content: center;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      gap: 20px;

      div {
        max-width: 320px;
      }
    }
  `}
`;

export const WrapperTitle = styled.div`
  align-items: center;
  display: flex;
  gap: 6px;
  justify-content: center;
`;

export const GuidePopoverContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 320px;
`;

export const GuidePopoverTitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryMedium};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.bold};
    margin: 0;
  `}
`;

export const GuidePopoverDescription = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xxs};
    margin: 0;
  `}
`;

export const CarouselWrapper = styled.div`
  ${({ theme }) => css`
    background-color: #ffffff;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 40px;
    overflow: hidden;
    padding: 32px;
    position: relative;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 24px 0;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      gap: 0;
    }
  `}
`;

export const CarouselContainer = styled.div`
  display: flex;
  transition: transform 0.3s ease;
  width: 100%;
`;

export const CarouselItem = styled.div`
  align-items: center;
  display: flex;
  flex: 0 0 100%;
  justify-content: center;
  max-width: 100%;
  margin-bottom: auto;
`;
